import {
    Back2Icon,
    BackIcon, Close2Icon, Close3Icon, DateIcon,
    DateLabel,
    DatePickerContainer,
    DatePickerContainerBg,
    DatePickerContainerContent,
    DatePickerContainerTitle, DateRow, DateSelect, MInput, MInputContainer, MModal, MModalHead
} from "./styles";
import { useApp } from "../../contexts";
import { ContainerCenter, ContainerRow, DesktopContainer, MobileContainer } from "../Container";
import { FormButton, FormButtonCancel } from "../Form";
import FormButton2 from "../FormCustom2/Button";
import moment from "moment";
import { useState } from "react";

export const DatePickerViewMobile = (props) => {
    const { T } = useApp();
    const [fromDate, setFromDate] = useState(
      props.fromDate ? moment(props.fromDate): moment().subtract(1, 'months')
    );
    const [toDate, setToDate] = useState(
      props.toDate ? moment(props.toDate) : moment()
    );
    const [visible, setVisible] = useState();

    const onChange = (date, field) => {
        if (field === 'fromDate') {
            setFromDate(date);
            props.onChange({
              fromDate: date,
              toDate,
            });
        }
        if (field === 'toDate') {
            setToDate(date);
            props.onChange({
              fromDate,
              toDate: date,
            });
        }
    }

    const onSubmit = () => {
        props.onChange({
            fromDate, toDate
        })
    }

    return (
      <>
        <MInputContainer>
          <MInput onClick={() => setVisible("fromDate")}>
            <span>{fromDate.format("DD/MM/YYYY") || T("From")}</span>
            <DateIcon />
          </MInput>
          <ContainerRow style={{ width: 15 }} />
          <MInput onClick={() => setVisible("toDate")}>
            <span>{toDate ? toDate.format("DD/MM/YYYY") : T("To")}</span>
            <DateIcon />
          </MInput>
        </MInputContainer>
        {visible ? (
          <MModal>
            {/* <MModalHead>
                        <Back2Icon onClick={() => setVisible("")} />
                        <Close2Icon onClick={() => setVisible("")} />
                    </MModalHead> */}
            <div
              onClick={() => setVisible("")}
              className="relative float-right right-6 top-3 w-[32px] bg-[#fff] h-[32px] rounded-2xl flex justify-center items-center"
            >
              <Close3Icon />
            </div>
            <DateSelect
              minDate={fromDate}
              maxDate={toDate}
              mode={visible === "fromDate" ? "min" : "max"}
              value={visible === "fromDate" ? fromDate : toDate}
              onSelect={(event) => {
                onChange(event, visible);
                setVisible("");
              }}
            />
          </MModal>
        ) : null}
      </>
    );
}